import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-460d93b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "loadingScreen",
  ref: "loadingScreen"
}
const _hoisted_2 = {
  class: "loadMark",
  ref: "loadMark",
  viewBox: "0 0 1024 1024",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "introPath light",
  d: "M919.065,11.13h-210.535l-78.924,150.939-39.444,75.469-19.722,37.735,100.098,192.244,21.174-38.917,42.383-77.833L919.065,11.13Z"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "introPath accent",
  d: "M616.011,567.816l-97.336-193.344L322.834,11.13H104.935L412.663,567.816l-249.554,445.055h210.535l242.366-445.055Z"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gradient_bg3_d = _resolveComponent("gradient-bg3-d")!
  const _component_cookie_view = _resolveComponent("cookie-view")!
  const _component_nav_mod = _resolveComponent("nav-mod")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_mod = _resolveComponent("footer-mod")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_gradient_bg3_d, {
        look: "rays",
        variant: "night",
        class: "loadBg"
      }),
      (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5, 512))
    ], 512),
    _createVNode(_component_cookie_view, { ref: "cookieManager" }, null, 512),
    _createVNode(_component_nav_mod, {
      "is-homepage": (_ctx.onHome === 1),
      "dark-hero": _ctx.darkHero,
      "blend-in": _ctx.navBlend
    }, null, 8, ["is-homepage", "dark-hero", "blend-in"]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view, {
        class: _normalizeClass(["view", _ctx.$route.name]),
        onLeave: _ctx.showLoading,
        onEnter: _ctx.hideLoading
      }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, { max: 6 }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.fullPath
            }))
          ], 1024))
        ]),
        _: 1
      }, 8, ["class", "onLeave", "onEnter"])
    ]),
    _createVNode(_component_footer_mod, { onOpenCookies: _ctx.openSettings }, null, 8, ["onOpenCookies"])
  ], 64))
}